import FlightSegment from './flight-segment-component';
import FlightSegmentService from './flight-segment-service';
import FlightGroupModule from './flight-group/flight-group-module';
import FlightSegmentAlternativesModule from './flight-segment-alternatives/flight-segment-alternatives-module';
import FlightSegmentDetailsFlightModule from './flight-segment-details-flight/flight-segment-details-flight-module';

import './flight-segment.scss';

const MODULE_NAME = 'app.flight.segment';
const module = angular.module(MODULE_NAME, [
        FlightGroupModule,
        FlightSegmentAlternativesModule,
        FlightSegmentDetailsFlightModule,
    ])
    .directive(FlightSegment.DIRECTIVE_NAME, FlightSegment)
    .service('flightSegmentService', FlightSegmentService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-module.js